import store from "@/store";

const routes = [
  {
    path: "/accounting/payments/:id",
    name: "acctpayments",
    component: () => import("@/views/main/modules/Accounting/Payments/PaymentsView.vue"),
    beforeEnter: (to, from, next) => {
      store
        .dispatch("checkAccessUser", to.params.id)
        .then((response) => {
          if (response == "fail") {
            next("/no-access");
          } else {
            next();
          }
        })
        .catch(() => {});
    },
    meta: {
      requiresAuth: true,
      title: "Payments",
    },
  },
];

export default routes;
